import { render } from "./ffupload.vue?vue&type=template&id=5557277e"
import script from "./ffupload.vue?vue&type=script&lang=js"
export * from "./ffupload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__